import { render, staticRenderFns } from "./ListSignaturePage.vue?vue&type=template&id=0313bffe&"
import script from "./ListSignaturePage.vue?vue&type=script&lang=js&"
export * from "./ListSignaturePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports